import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonHelper } from '../helpers/common';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private commonHelper: CommonHelper,
    private auth: AuthService,
    private router: Router) { }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const extras: any = { lastUrl: state.url };
    if (this.auth.isAuthenticate()) {
      // this.router.navigateByUrl('/player');
      return true;
    } else {
      this.commonHelper.prevUrl = state.url;
      this.router.navigateByUrl('/home', extras);
      return false;
    }
  }
}
